import React, { useEffect, useMemo } from "react";
import MdaeButton from "../button";
import { useSelector, useDispatch } from "react-redux";
import { actions } from "async-ops";
import MdaeActionPopover from "../menu-action-popover";
import { SET_MDAE_NAVIGATION_BAR_CONFIG } from "../navigation_bar/reducers/mdae-navigation-bar-reducer";
import {
    TOGGLE_HELP_ACTION_POPOVER,
    TOGGLE_USER_ACTION_POPOVER,
} from "./reducers/mdae-page-header-reducer";
import { GET_CLIENT_LOGO } from "./services/get-client-logo";
import { isEqual } from "lodash";
import $ from "jquery";
import { logoutAll } from "../../../app/ApplicationEventHandler";
import { toggleNotificationsPanelOpen } from "../notification-and-system-messages-module/component";
import "./index.scss";
import { FG_EXTERNAL_USER_TASK_EDITING, hasAnyFeatureGroupAccess } from "../../user-permissions-helper";
import { checkIsQioReviewContractor } from "../../../pages/external-audit-setup/requestor-and-sources/requester/add-requester";
interface IMdaePageHeaderProps {
    showTermsOfUse?: boolean;
    clientName?: string;
    loggedInUserDisaplyName?: string;
    userLoggedIn?: string;
    history?: any;
    isMdaeNavigationBarExpanded?: boolean;
}
const MdaePageHeader: React.FC<IMdaePageHeaderProps> = (props) => {
    const isMdaeNavigationBarExpanded = useSelector(
        (state) => state["mdaeNavigationBarReducer"].isMdaeNavigationBarExpanded
    );
    const currentUser = useSelector(
        (state) => state["mdaeNavigationBarReducer"].currentUser,
        isEqual
    );
    const applicationConfiguration = useSelector(
        (state) => state["mdaeNavigationBarReducer"].applicationConfigurations,
        isEqual
    );

    const companyLogo = useSelector(
        (state) => state["mdaePageHeaderReducer"].companyLogo,
        isEqual
    );
    const isCompanyLogoLoded = useSelector(
        (state) => state["mdaePageHeaderReducer"].isCompanyLogoLoded,
        isEqual
    );
    const mdaeFirstMenuObject = useSelector(
        (state) => state["mdaeNavigationBarReducer"].mdaeFirstMenuObject,
        isEqual
    );
    const isNotificationPanelOpen = useSelector(
        (state: any) =>
            state.notificationAndSystemMessagesReducer.isNotificationPanelOpen
    );
    const unreadMessagesCount = useSelector(
        (state) =>
            state["notificationAndSystemMessagesReducer"].systemMessageList?.filter(
                (x) => !x?.read
            )?.length,
        isEqual
    );
    const unreadNotificationsCount = useSelector(
        (state) =>
            state["notificationAndSystemMessagesReducer"]?.notificationList?.filter(
                (x) => !x?.isNotificationRead
            )?.length,
        isEqual
    );
    const isExternalUser = useMemo(
        () => hasAnyFeatureGroupAccess([FG_EXTERNAL_USER_TASK_EDITING], currentUser),
        [currentUser]
    );

    let tempCompanyLogo = localStorage.getItem("client-logo");
    useEffect(() => {
        tempCompanyLogo = localStorage.getItem("client-logo");
        if (tempCompanyLogo === null && !isCompanyLogoLoded) {
            dispatch(actions.asyncOperationStart(GET_CLIENT_LOGO, {}));
        } else {
            if (tempCompanyLogo || companyLogo) {
                localStorage.setItem("client-logo", tempCompanyLogo || companyLogo);
            } else {
                localStorage.setItem("client-logo", "undefined");
            }
            tempCompanyLogo = localStorage.getItem("client-logo");
            if (tempCompanyLogo !== "undefined") {
                var imageSource = "data:image/jpeg;base64," + tempCompanyLogo;
                $("#clientLogo").html(
                    '<img class="company-header-logo" src=' +
                    imageSource +
                    '  alt="Client Logo" />'
                );
            }
        }
    }, [isCompanyLogoLoded]);
    const actionPopoverMenuList = [
        {
            text: "Profile",
            icon: () => {
                return (
                    <div
                        style={{ height: "14px" }}
                        className={"fa fa-user sys-user-menu-action-item-icon"}
                    ></div>
                );
            },
            onClick: () => {
                window.location.href = "/user/userprofile/";
            },
        },
        {
            text: "Change Password",
            icon: () => {
                return (
                    <div
                        style={{ height: "16px" }}
                        className={"fa fa-lock sys-user-menu-action-item-icon"}
                    ></div>
                );
            },
            visible: !currentUser?.isSSOClient,
            onClick: () => {
                window.location.href = "/Account/ChangePassword";
            },
        },
        {
            text: "Logout",
            icon: () => {
                return (
                    <div
                        style={{ height: "16px" }}
                        className={"fa fa-sign-out sys-user-menu-action-item-icon"}
                    ></div>
                );
            },
            onClick: logoutAll,
        },
        {
            text: currentUser?.isHayesAdmin ? "Choose Customer" : "Choose Client",
            icon: () => {
                return (
                    <div
                        style={{ height: "16px" }}
                        className={"fa fa-building sys-user-menu-action-item-icon"}
                    ></div>
                );
            },
            visible:
                currentUser?.isHayesGeneralAccess &&
                (currentUser?.isHayesAdmin ||
                    currentUser?.isClientGroup ||
                    currentUser?.clientGroupParentId),
            onClick: () => {
                window.location.href = "/admin/clientchooser";
            },
        },
    ];
    const helpIconActionPopoverMenuList = [
      {
        text: "Release Notes",
        icon: () => {
          return (
            <div
              style={{ height: "14px" }}
              className={"fas fa-book sys-user-menu-action-item-icon"}
            ></div>
          );
        },
        onClick: () => {
          window.open(
            "../help/Content/Shared-Content/Release-Notes/Release-Notes.htm",
            "_blank"
          );
        },
      },
      {
        text: "User Documentation",
        icon: () => {
          return (
            <div
              style={{ height: "14px" }}
              className={"fas fa-book sys-user-menu-action-item-icon"}
            ></div>
          );
        },
        onClick: () => {
          window.open("/home/help", "_blank");
        },
      },
      {
        text: "Support",
        icon: () => {
          return (
            <div
              style={{ height: "16px" }}
              className={"fa fa-phone-square sys-user-menu-action-item-icon"}
            ></div>
          );
        },
        onClick: () => {
            window.open(applicationConfiguration.supportURL);
        },
      },
      {
        text: "Learn",
        icon: () => {
          return (
            <div
              style={{ height: "16px" }}
              className={"fas fa-graduation-cap sys-user-menu-action-item-icon"}
            ></div>
          );
        },
        visible: currentUser?.learnEnableInd,
        onClick: () => {
          window.open(applicationConfiguration.learnURL);
        },
      },
      {
        text: applicationConfiguration?.supportCommunityText,
        icon: () => {
          return (
            <div
              style={{ height: "16px" }}
              className={"fa fa-phone-square sys-user-menu-action-item-icon"}
            ></div>
          );
        },
          visible: currentUser?.communityEnabled,
        onClick: () => {
          window.open(applicationConfiguration.supportCommunityURL);
        },
      },
      {
        text: "Code Search",
        icon: () => {
          return (
            <div
              className={"sys-user-menu-action-item-code-look-up"}
            ></div>
          );
        },
        onClick: () => {
          window.open('/lookup/index', 'Code Search', 'width=1220,height=600,scrollbars=1');
        },
      },
      {
        text: "Accelerator",
        icon: () => {
          return (
            <div
              style={{ height: "16px" }}
              className={"fa fa-globe sys-user-menu-action-item-icon"}
            ></div>
          );
        },
        visible: currentUser?.acceleratorAccessInd,
        onClick: () => {
          window.open(applicationConfiguration.acceleratorURL);
        },
      },
    ];
    const dispatch = useDispatch();
    return (
      <div className="mdae-topmenu-outer">
        <div className="mdae-topmenu">
          {!props.showTermsOfUse && (
            <div
              className="mdae-menu"
              style={{
                width: "80px",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <MdaeButton
                id={""}
                role={"dxButton"}
                stylingMode={"text"}
                onClick={(e) => {
                  localStorage.setItem(
                    "is-mdae-navigation-bar-expanded",
                    !isMdaeNavigationBarExpanded + ""
                  );
                  dispatch({
                    type: SET_MDAE_NAVIGATION_BAR_CONFIG,
                    data: {
                      isMdaeNavigationBarExpanded: !isMdaeNavigationBarExpanded,
                    },
                  });
                }}
                style={{ border: "unset" }}
              >
                <img
                  src={
                    isMdaeNavigationBarExpanded
                      ? "/images/ui-rewrite-icons/drawermenubackbuttonicon.svg"
                      : "/images/ui-rewrite-icons/drawermenubackbuttoniconmin.svg"
                  }
                  alt="Mdae Menu"
                />
              </MdaeButton>
            </div>
          )}

          <div
            className="mdae-topmenu-left align-items-center"
            style={{
              width: "200px",
              marginLeft: "0px",
              paddingLeft: "0px",
              height: "100%",
            }}
            onClick={() => {
              if (mdaeFirstMenuObject.isReactMenu) {
                props.history.push(mdaeFirstMenuObject.menuUrl);
              } else {
                window.location.href = mdaeFirstMenuObject.menuUrl;
              }
            }}
          >
            <img
              className="header-logo"
              src="/images/ui-rewrite-icons/MDAuditHayes_Logo.png"
              alt="MDAudit Enterprise Logo"
            />
            <div style={{ display: "none" }} className="company-title">
              <span>{currentUser?.clientName}</span>
            </div>
          </div>

          <div className="mdae-topmenu-right">
            <div className="client-name" style={{ flexFlow: "column" }}>
              <div className={"image-container"}>
                {tempCompanyLogo !== "undefined" && (
                  <div
                    title={currentUser?.clientCode}
                    id="clientLogo"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  ></div>
                )}
                {tempCompanyLogo === "undefined" && (
                  <div
                    ng-if="!hw.companyLogo"
                    title={currentUser?.clientCode}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {currentUser?.clientName}
                  </div>
                )}
              </div>
              <div
                id="pnlDummyReferenceForUiDemo"
                style={{ marginRight: "350px" }}
              ></div>
            </div>
            <div className="line"></div>
            {isExternalUser || (
              <>
                <div className="more-actions">
                  <div
                    className="help"
                    title="Help"
                    id="helpIcon"
                    onClick={() => {
                      dispatch({
                        type: TOGGLE_HELP_ACTION_POPOVER,

                        data: {
                          isHelpActionMenuPopoverVisible: true,
                        },
                      });
                    }}
                    style={{ marginRight: "20px" }}
                  >
                    <div className="help-circle hand-hover"></div>
                  </div>
                </div>

                <div
                  id="showMessages"
                  className={
                    isNotificationPanelOpen
                      ? "show-messages notication-icon notification-icon-selected"
                      : "show-messages notication-icon"
                  }
                  role="button"
                  onClick={() =>
                    toggleNotificationsPanelOpen(
                      isNotificationPanelOpen,
                      dispatch
                    )
                  }
                >
                  <span
                    className="fa-stack"
                    style={{ height: "unset", lineHeight: "unset" }}
                  >
                    <span
                      className="fa fa-bell"
                      style={{
                        color: "grey",
                        height: "24px",
                        width: "19px",
                        fontSize: "22px",
                      }}
                    ></span>
                    {isNotificationPanelOpen || (
                      <>
                        <i
                          id="unreadCountBubble"
                          className={
                            unreadMessagesCount + unreadNotificationsCount > 0
                              ? "fa fa-circle fa-stack-2x message-bubble has-unread"
                              : "fa fa-circle fa-stack-2x message-bubble"
                          }
                          style={{ color: "#428bca" }}
                        ></i>

                        <strong
                          id="unreadMessageCount"
                          className="fa-stack-1x message-text"
                        >
                          {unreadMessagesCount + unreadNotificationsCount}
                        </strong>
                      </>
                    )}
                  </span>
                </div>
              </>
            )}
            <div className="logged-user">
              <div style={{ flex: "0 0 auto", alignItems: "stretch" }}>
                <i
                  className="fa fa-user-circle-o"
                  style={{ fontSize: "24px" }}
                ></i>
              </div>
              <div className="username">
                {currentUser?.loggedInUserDisaplyName}
              </div>
              <div
                className="username"
                id="user-logged-in"
                style={{ display: "none" }}
              >
                {props.userLoggedIn}
              </div>
              <div className="more-actions">
                <div
                  id="product3"
                  className="dx-icon-chevrondown"
                  onClick={() => {
                    dispatch({
                      type: TOGGLE_USER_ACTION_POPOVER,

                      data: {
                        isUserActionMenuPopoverVisible: true,
                      },
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <MdaeActionPopover
          mdaePopoverConfig={{
            target: "#product3",
            position: "top",
            mdaeDataUpdaterConfig: [
              {
                actionType: TOGGLE_USER_ACTION_POPOVER,
                reducerName: "mdaePageHeaderReducer",
                widgetOptionBindings: {
                  visible: "isUserActionMenuPopoverVisible",
                },
              },
            ],
          }}
          menuItemList={actionPopoverMenuList}
        ></MdaeActionPopover>
        <MdaeActionPopover
          mdaePopoverConfig={{
            position: "top",
            target: "#helpIcon",
            mdaeDataUpdaterConfig: [
              {
                actionType: TOGGLE_HELP_ACTION_POPOVER,
                reducerName: "mdaePageHeaderReducer",
                widgetOptionBindings: {
                  visible: "isHelpActionMenuPopoverVisible",
                },
              },
            ],
          }}
          menuItemList={helpIconActionPopoverMenuList}
        ></MdaeActionPopover>
      </div>
    );
};
export default MdaePageHeader;
